import { Component, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'projects/visualize3d/src/public-api';

@Component({
  selector: 'app-preferences-dialog',
  templateUrl: './preferences-dialog.component.html',
  styleUrls: ['./preferences-dialog.component.css'],
  standalone: false,
})
export class PreferencesDialogComponent implements OnInit {
  private apiService = inject(ApiService);
  dialogRef = inject<MatDialogRef<PreferencesDialogComponent>>(MatDialogRef);

  apiRootFormControl: FormControl<string> | null = null;

  ngOnInit(): void {
    this.apiService.getCurrentApiUrl().subscribe(apiRoot => {
      this.apiRootFormControl = new FormControl(apiRoot);
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
